import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import { getArtworkPurchaseGalleryProfile } from '@/pages/artwork/utils/artworkView.selectors';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';

import './styles/PersonalizedMessage.css';

function Content({ close, purchaseState, addPersonalizedMessage }) {
  const t = useTranslations('common.shared.artwork_view.personalized_message');
  const [formState, setFormState] = useState(purchaseState.personalized_message || "");
  const isSubmitDisabled = !formState.trim().length;

  return (
    <>
      <div className="purchase-personalized-message__header">
        <span className="purchase-personalized-message__header-text">
          {t('popup.title')}
        </span>

        <XIcon className="purchase-personalized-message__close" onClick={close}/>
      </div>

      <p className="purchase-personalized-message__popup-text">
        {t('popup.description')}
      </p>

      <textarea 
        placeholder={t('popup.placeholder')}
        value={formState}
        onChange={e=>setFormState(e.target.value)}
        spellCheck={false}
        className="purchase-personalized-message__textarea"
      />

      <ContinueButton 
        className="purchase-personalized-message__add-button"
        turnOff={isSubmitDisabled} 
        onClick={()=>addPersonalizedMessage(formState)}
      >
        {
          purchaseState.personalized_message ?
            t('popup.actions.update')
            :
            t('popup.actions.add')
        }
      </ContinueButton>
    </>
  );
}

export default function PersonalizedMessage({ formState, setFormState, artworkData, typeOfPurchase }) {
  const t = useTranslations('common.shared.artwork_view.personalized_message');
  const galleryProfile = getArtworkPurchaseGalleryProfile(artworkData);
  const [openPersonzalizedMessage, setOpenPersonalizedMessage] = useState(false);
  const hasPersonalizedMessage = Boolean(formState.personalized_message && formState.personalized_message.trim().length);
  const messagePreview = hasPersonalizedMessage
    ? formState.personalized_message.trim().split(/\r?\n/).slice(0, 2).join('\n')
    : "";

  function addPersonalizedMessage(message) {
    const normalizedMessage = message.trim();
    setFormState({ ...formState, personalized_message: normalizedMessage });
    setOpenPersonalizedMessage(false);
  }

  function removePersonalizedMessage(e) {
    e.stopPropagation();
    setFormState({ ...formState, personalized_message: "" });
  }

  return (
    <>
      <span 
        className={`purchase-personalized-message__text element-non-selectable ${hasPersonalizedMessage ? "with-message" : ""}`}
        onClick={()=>setOpenPersonalizedMessage(true)}
      >
        {
          hasPersonalizedMessage ? (
            <>
              <span className="purchase-personalized-message__label-row">
                <span className="purchase-personalized-message__label">{t('added_label')}</span>

                <XIcon className="purchase-personalized-message__remove" onClick={removePersonalizedMessage}/>
              </span>

              <span className="purchase-personalized-message__preview">
                {messagePreview}  {/* Add the three dots Pablo */}
              </span>
            </>
          ) : (
            typeOfPurchase === "limited_edition" ?
              t('add_to_suarte')
              :
              t('add_to_gallery', { galleryName: galleryProfile.name })
          )
        }
      </span>

      <GenericPopup
        open={openPersonzalizedMessage}
        className="purchase-personalized-message__popup"
        darkerBlur
      >
        <Content 
          purchaseState={formState} 
          addPersonalizedMessage={addPersonalizedMessage}
          close={()=>setOpenPersonalizedMessage(false)}
        />
      </GenericPopup>
    </>
  );
}
